// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__vKsdO","col":"styles_col__2w8WU"};